import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Upload, FileSpreadsheet, ArrowLeft, CheckCircle2 } from "lucide-react";

export default function Importar() {
  const nav = useNavigate();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const send = async () => {
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/import/planilha", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setResult(r.data);
      toast.success(`${r.data.imported} clientes importados!`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erro ao importar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <button onClick={() => nav(-1)} className="text-sm text-stone-500 hover:text-stone-800 inline-flex items-center gap-1 mb-3">
        <ArrowLeft className="w-4 h-4" /> Voltar
      </button>
      <h1 className="font-display text-3xl font-extrabold tracking-tight text-stone-900 mb-1">Importar Planilha</h1>
      <p className="text-sm text-stone-500 mb-5">Traga sua caderneta antiga (Excel .xlsx ou .csv).</p>

      <div className="carne-card p-5" data-testid="spreadsheet-dropzone">
        <label className="block cursor-pointer">
          <input
            data-testid="input-spreadsheet-file"
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={(e) => { setFile(e.target.files?.[0] || null); setResult(null); }}
            className="hidden"
          />
          <div className="w-full aspect-[4/2] rounded-xl border-2 border-dashed border-stone-300 bg-white flex flex-col items-center justify-center gap-2 text-stone-600 hover:border-[color:var(--terracotta)] transition-colors">
            <FileSpreadsheet className="w-10 h-10 text-[color:var(--terracotta)]" strokeWidth={1.8} />
            <div className="font-display font-bold">{file ? file.name : "Escolher planilha"}</div>
            <div className="text-xs text-stone-500">.xlsx, .xls ou .csv</div>
          </div>
        </label>

        <button
          data-testid="btn-upload-spreadsheet"
          onClick={send}
          disabled={!file || loading}
          className="btn-primary w-full mt-3"
        >
          <Upload className="w-4 h-4" /> {loading ? "Importando..." : "Enviar e importar"}
        </button>

        <div className="mt-4 text-xs text-stone-500 space-y-1">
          <div className="font-bold uppercase tracking-wider text-stone-600">Dica de colunas reconhecidas</div>
          <div>• <b>nome / cliente</b> (obrigatório)</div>
          <div>• telefone / whatsapp / celular</div>
          <div>• bairro / cidade</div>
          <div>• endereço / rua</div>
          <div>• observações / notas</div>
        </div>
      </div>

      {result && (
        <div className="carne-card p-4 mt-4 animate-slide-up" data-testid="import-progress-status">
          <div className="flex items-center gap-2 mb-2">
            <CheckCircle2 className="w-5 h-5 text-emerald-600" />
            <h3 className="font-display font-bold">Importação concluída</h3>
          </div>
          <div className="text-sm text-stone-700 space-y-1">
            <div>Clientes importados: <b>{result.imported}</b></div>
            <div>Linhas ignoradas: {result.skipped}</div>
            <div className="text-xs text-stone-500 mt-2">Colunas detectadas: {result.colunas?.join(", ")}</div>
          </div>
          <button onClick={() => nav("/clientes")} className="btn-primary w-full mt-3">Ver clientes</button>
        </div>
      )}
    </div>
  );
}
